import React, { useEffect } from "react";

import {
  UncontrolledDropdown,
  DropdownToggle,
} from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import MsgDataService from "../../../services/MsgService";
import { messageNotificationAction } from "../../../reducers/MessageNotificationReducer";
import { Roles } from "../../../utils/Roles";
import { useHistory } from "react-router-dom";
import MessageBell from "../../../assets/images/bell/MessageBell.png";
import NotifyBadge from "./NotifyBadge";
import { getParentNotificationCount } from "../../../utils/parentNotificationCount";

const HeaderDots = () => {
  let dispatch = useDispatch();
  let history = useHistory();
  let userData = useSelector(state => state.UserReducer.userObj);
  let notificationData = useSelector(state => state.MessageNotificationReducer.messageNotification);
  const isImpersonating = useSelector(state => state.ImpersonationReducer?.isImpersonating);

  useEffect(() => {
    // Skip notification API calls when in impersonation mode
    if (isImpersonating) {
      return;
    }
    if (userData?.role === Roles.STUDENT_NAME) {
      getUnreadCountforStudentRole();
    } else if (userData?.role === Roles.PARENT_NAME) {
      getParentDefaultCount();
    }
  }, [isImpersonating]);

  const getUnreadCountforStudentRole = () => {
    MsgDataService.getUnreadCountForStudent()
      .then((res) => {
        if (res?.status === 200) {
          dispatch(messageNotificationAction(res?.data?.total_notification))
        }
      })
      .catch(() => {});
  };

  const getParentDefaultCount = () => {
    MsgDataService.getTotalParentCount()
      .then((res) => {
        if (res?.status !== 200) return;
        dispatch(messageNotificationAction(getParentNotificationCount(res?.data)));
      })
      .catch(() => {});
  }

  // const getStudentWiseunreadCount = (userId, school_Id) => {
  //   let payload = {
  //     user_id: userId,
  //     school_id: school_Id
  //   }
  //   setLoading(true);
  //   MsgDataService.getParentRoleTotalUnreadCount(payload)
  //     .then(res => {
  //       if (res?.status === 200) {
  //         dispatch(messageNotificationAction(res?.data?.total_notification))
  //       }
  //       setLoading(false);
  //     }).catch(error => {
  //       setLoading(false);
  //     })
  // }

  const handleClickNotify = () => {
    if (userData?.role === Roles.STUDENT_NAME) {
      history.push(`/student/message`);
    } else if (userData?.role === Roles.PARENT_NAME) {
      history.push(`/parent/message`);
    }
  }

  return (
    <>
      <div className="header-dots">
        <UncontrolledDropdown>
          <DropdownToggle className="p-0 mr-2" color="link">
            {userData.role === 'student' ?
              <div className="icon-wrapper icon-wrapper-alt" onClick={handleClickNotify}>
                <img src={MessageBell} alt='notifyIcon' width={32} height={26} className='img-fluid' />
                {!isImpersonating && <NotifyBadge count={notificationData} />}
              </div> : ''}
            {userData.role === 'parent' ?
              <div className="icon-wrapper icon-wrapper-alt" onClick={handleClickNotify}>
                <img src={MessageBell} alt='notifyIcon' width={32} height={26} className='img-fluid' />
                {!isImpersonating && <NotifyBadge count={notificationData} />}
              </div> : ''}

          </DropdownToggle>
          {/* <DropdownMenu right className="dropdown-menu-xl rm-pointers">
          <div className="dropdown-menu-header mb-0">
            <div className="dropdown-menu-header-inner bg-deep-blue">
              <div
                className="menu-header-image opacity-1"
                style={{
                  backgroundImage: "url(" + city3 + ")",
                }}
              />
              <div className="menu-header-content text-dark">
                <h5 className="menu-header-title">Notifications</h5>
                <h6 className="menu-header-subtitle">
                  You have <b>21</b> unread messages
                </h6>
              </div>
            </div>
          </div>
          <Tabs
            tabsWrapperClass="body-tabs body-tabs-alt"
            transform={false}
            showInkBar={true}
            items={getTabs()}
          />
          <Nav vertical>
            <NavItem className="nav-item-divider" />
            <NavItem className="nav-item-btn text-center">
              <Button
                size="sm"
                className="btn-shadow btn-wide btn-pill"
                color="focus"
              >
                View Latest Changes
              </Button>
            </NavItem>
          </Nav>
        </DropdownMenu> */}
        </UncontrolledDropdown>
      </div>
    </>
  )
}

export default HeaderDots
